import { render } from "./ResetPasswordForUser.vue?vue&type=template&id=5dafd0bd"
import script from "./ResetPasswordForUser.vue?vue&type=script&lang=js"
export * from "./ResetPasswordForUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__